import { render } from "./oncology_history.vue?vue&type=template&id=7eb4249a&scoped=true"
import script from "./oncology_history.vue?vue&type=script&lang=js"
export * from "./oncology_history.vue?vue&type=script&lang=js"

import "./oncology_history.vue?vue&type=style&index=0&id=7eb4249a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb4249a"]])

export default __exports__